/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import { unparse } from 'papaparse';
import download from 'downloadjs';

import ConfirmModal from '../../scenes/myTeams/ConfirmModal';

type Props = {
  autoDownload?: boolean,
  children: React.Node,
  className?: string,
  data: Array<Object<{ [string]: [string] }>>,
  filename: string,
  fields: Object<{ [string]: [string] }>,
  isRacing?: boolean
};

type State = {
  showConfirm: boolean
};

const DownloadButton = styled.button(({ theme }) => ({
  alignItems: 'center',
  color: theme.color.basis1,
  display: 'flex'
}));

class ExportButton extends React.PureComponent<Props> {
  props: Props;

  state: State = {
    showConfirm: false
  };

  ref: HTMLButtonElement; // eslint-disable-line react/sort-comp

  static defaultProps = {
    autoDownload: false
  };

  componentDidMount() {
    const { autoDownload } = this.props;

    if (autoDownload) {
      this.ref.click();
    }
  }

  handleRef = ref => {
    this.ref = ref;
  };

  handleCancel = () => this.setState({ showConfirm: false });

  handleConfirm = () => this.setState({ showConfirm: true });

  handleDownload = () => {
    this.handleCancel();

    const { data, fields, filename } = this.props;

    const content = unparse([fields, ...data], { header: false });
    const blob = new window.Blob([content], { type: 'data:text/csv;charset=utf-8' });
    download(blob, filename, 'text/csv');
  };

  render() {
    const { children, className, isRacing } = this.props;
    const { showConfirm } = this.state;

    return (
      <React.Fragment>
        <DownloadButton
          innerRef={this.handleRef}
          className={className}
          onClick={this.handleConfirm}
          type="botton"
        >
          {children}
        </DownloadButton>
        {showConfirm && (
          <ConfirmModal
            title={`Tips: you can exclude/include inactive ${
              isRacing ? 'horses' : 'players'
            } by toggling the checkbox.`}
            isLoading={false}
            label="Download"
            onCancel={this.handleCancel}
            onSubmit={this.handleDownload}
          />
        )}
      </React.Fragment>
    );
  }
}

ExportButton.defaultProps = {
  className: undefined,
  isRacing: false
};

export default ExportButton;
